<template>
  <div class="part-eight">
    <div class="title" style="margin-bottom: 60px;">
      <div style="font-size: 40px; color: #000000; font-weight: bold">
        服务全国40000+客户的行业案例
      </div>
      <div style="margin-top: 30px;" class="flex-center">
        <span style="font-size: 24px;color:#404040;font-weight: 400;margin-right: 20px;">芸众完善的服务体系为企业数字化经营保驾护航</span>
        <span style="font-size: 24px; color: #007EFF; cursor: pointer;" class="flex-center" @click="openDialog">
          查看更多案例 <i class="iconfont icon-icon_more11" style="margin-left: 5px;font-size: 22px;color:#007EFF;"></i>
        </span>
      </div>

    </div>
    <!-- <div class="taps">
      <div class="taps-item" :style="{ color: activeIndex == index ? '#203DF5' : '#000000' }" @click="changIndex(index)"
        v-for="(item, index) in tapsList" :key="index">{{ item }}
        <div :class="{ 'blod-line': activeIndex == index }"></div>
      </div>

    </div> -->
    <!-- <div class="taps-line"></div> -->
    <div id="swipercom">
      <div class="swipercom-left"></div>
      <div class="swipercom-right"></div>
      <div class="swiper-container" id="swiperIndex3" ref="swiperContainer">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in video_list" :key="item.id" >
            <div class="play"  @click.stop="handle(item.id)">
              <i class="iconfont icon-play"></i>
            </div>
            <img :src="item.cover" alt="" />
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;padding: 20px;">
          <div class="swiper-pagination"></div>
        </div>
      </div>

    </div>


    <!-- <div class="img-show">
      <div class="img-show-left">
        <div style="opacity: 0.3;">
          <svg t="1692777021543" class="icon" viewBox="0 0 1316 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="92115" width="40" height="40">
            <path
              d="M175.542857 789.942857c-40.228571-40.228571-62.171429-102.4-62.171428-182.857143 0-98.742857 32.914286-190.171429 98.742857-274.285714s157.257143-138.971429 274.285714-168.228571l32.914286-7.314286 87.771428 164.571428-51.2 21.942858c-43.885714 18.285714-84.114286 40.228571-117.028571 65.828571-32.914286 25.6-54.857143 47.542857-69.485714 73.142857 62.171429 0 113.371429 18.285714 153.6 54.857143s62.171429 80.457143 62.171428 131.657143c0 54.857143-21.942857 102.4-62.171428 135.314286-43.885714 40.228571-106.057143 62.171429-179.2 62.171428-62.171429 0-117.028571-25.6-168.228572-76.8z m603.428572 0c-40.228571-40.228571-62.171429-102.4-62.171429-182.857143 0-98.742857 32.914286-190.171429 98.742857-274.285714s157.257143-138.971429 274.285714-168.228571l32.914286-7.314286 87.771429 164.571428-51.2 21.942858c-43.885714 18.285714-84.114286 40.228571-117.028572 65.828571-32.914286 25.6-54.857143 47.542857-69.485714 73.142857 62.171429 0 113.371429 18.285714 153.6 54.857143s62.171429 80.457143 62.171429 131.657143c0 54.857143-21.942857 102.4-62.171429 135.314286-43.885714 40.228571-106.057143 62.171429-179.2 62.171428-58.514286 0-117.028571-25.6-168.228571-76.8z"
              fill="#DCDCDC" p-id="92116"></path>
          </svg>
        </div>
        <div>
          <div style="font-size:28px;color:#FFFFFF;margin-top:30px">{{ activeItem.title }}</div>
          <div style="    font-size: 20px;margin-top: 13px;color: #ffffff;">{{ activeItem.des }}</div>
        </div>
        <div style="opacity: 0.3;position: relative;">
          <svg style="position: absolute;bottom: 0;" t="1692777111625" class="icon" viewBox="0 0 1316 1024"
            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="92266" width="40" height="40">
            <path
              d="M1141.028571 234.057143c40.228571 40.228571 62.171429 102.4 62.171429 182.857143 0 98.742857-32.914286 190.171429-98.742857 274.285714s-157.257143 138.971429-274.285714 168.228571l-32.914286 7.314286-87.771429-164.571428 51.2-21.942858c43.885714-18.285714 84.114286-40.228571 117.028572-65.828571 32.914286-25.6 54.857143-47.542857 69.485714-73.142857-62.171429 0-113.371429-18.285714-153.6-54.857143S731.428571 405.942857 731.428571 354.742857c0-54.857143 21.942857-102.4 62.171429-135.314286 43.885714-40.228571 106.057143-62.171429 179.2-62.171428 62.171429 0 117.028571 25.6 168.228571 76.8z m-603.428571 0c40.228571 40.228571 62.171429 102.4 62.171429 182.857143 0 98.742857-32.914286 190.171429-98.742858 274.285714s-157.257143 138.971429-274.285714 168.228571l-32.914286 7.314286-87.771428-164.571428 51.2-21.942858c43.885714-18.285714 84.114286-40.228571 117.028571-65.828571 32.914286-25.6 54.857143-47.542857 69.485715-73.142857-62.171429 0-113.371429-18.285714-153.6-54.857143s-62.171429-80.457143-62.171429-131.657143c0-54.857143 21.942857-102.4 62.171429-135.314286 43.885714-40.228571 106.057143-62.171429 179.2-62.171428 58.514286 0 117.028571 25.6 168.228571 76.8z"
              fill="#DCDCDC" p-id="92267"></path>
          </svg>
        </div>
      </div>
      <div class="img-show-right">
        <img :src="activeItem.img" alt="" style="width:100%;height:100%">
      </div>
    </div> -->
    <div style="margin-top:40px">
      <img :src="require('../assets/image_1/274.png')" alt="">
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css"; //引入swiper样式   
import Swiper from "swiper"; //引入swiper  
export default {
  data() {
    return {
      imgList: ['../assets/image_1/banner_1.png', '../assets/image_1/banner_2.png', '../assets/image_1/banner_3.png', '../assets/image_1/banner_4.png', '../assets/image_1/banner_5.png'],
      activeItem: {},
      activeName: 'second',
      dataList: [
        {
          title: "保力茶公社",
          des: '便捷化的购物模式，随时看茶购茶，分享品茶经验，交流茶道艺术。',
          img: require('../assets/part-eight-img1.png')
        },
        {
          title: "尚美葆美业",
          des: '重视皮肤健康，还原美丽人生。',
          img: require('../assets/part-eight-img2.png')
        },
        {
          title: "昊祥邻里聚金广场",
          des: '全新升级的精品社区生活中心，全自持物业统一运营管理。',
          img: require('../assets/part-eight-img3.png')
        },
        {
          title: "欣果铺子",
          des: '全新升级的精品社区生活中心，全自持物业统一运营管理。',
          img: require('../assets/part-eight-img4.png')
        },
        {
          title: "蒸善堂",
          des: '中医健康理疗门店连锁品牌。',
          img: require('../assets/part-eight-img5.png')
        }
      ],
      tapsList: ['茶水酒品', '美妆个护', '日常生活', '食品饮料', '健康保健'],
      activeIndex: 0,
      mySwiper: null,
      video_list: [],
    };
  },

  methods: {
    handle(id) {
      window.open(`https://www.yunzmall.com/plugins/shop_server/videoDetail?video_goods_id=${id}&page=1&category=true&i=10`)
    },
    getData() {
      this.video_list = [
        {
          id: 734,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '骏骁名酒名茶',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/5f9931fd56e0ca990fa3cf433348fecc.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/2d6d7e7391a1d5b0238f5cb20f6dd5fa.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:40:51',
          updated_at: '2025-07-14 16:06:28',
          deleted_at: null,
          file_name: '2d6d7e7391a1d5b0238f5cb20f6dd5fa.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 62,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/2d6d7e7391a1d5b0238f5cb20f6dd5fa.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 733,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '小象醉优选商城',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/e6307be7f4160d49def355ec1c936d00.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/360286a4a1ad6a3c4fb2d6b248586549.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:40:19',
          updated_at: '2025-07-10 17:50:41',
          deleted_at: null,
          file_name: '360286a4a1ad6a3c4fb2d6b248586549.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 76,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/360286a4a1ad6a3c4fb2d6b248586549.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 732,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '龙祥婚庆道具',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/4f856eb35eede62e6d57eb72f99ac63c.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/ed14c36099cef06e0546ff8d5aca7fbf.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:39:44',
          updated_at: '2025-07-09 14:14:35',
          deleted_at: null,
          file_name: 'ed14c36099cef06e0546ff8d5aca7fbf.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 40,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/ed14c36099cef06e0546ff8d5aca7fbf.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 731,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '唐妆国际',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/5ba494187862a2708ab7543813811cf2.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/f6136366980c2ad5fedbe2a6a240281b.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:39:14',
          updated_at: '2025-07-09 14:14:38',
          deleted_at: null,
          file_name: 'f6136366980c2ad5fedbe2a6a240281b.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 45,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/f6136366980c2ad5fedbe2a6a240281b.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 730,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '书香新华',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/ca44534674cb94fbe46d79af6a4cc1b3.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/155b8cff46d0f9979d2444ca16acc810.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:38:36',
          updated_at: '2025-07-10 17:50:51',
          deleted_at: null,
          file_name: '155b8cff46d0f9979d2444ca16acc810.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 26,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/155b8cff46d0f9979d2444ca16acc810.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 729,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '叻沙哥商城',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/5a393c312a628ea6abb3fcef16348c69.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/7e09625be4db2fb05e1bed1b23dc5514.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:37:53',
          updated_at: '2025-07-09 14:14:44',
          deleted_at: null,
          file_name: '7e09625be4db2fb05e1bed1b23dc5514.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 22,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/7e09625be4db2fb05e1bed1b23dc5514.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 728,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '蜜都下单系统',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/5bf08fa15223aac1b22d6bce8de5c069.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/1bc77485e78794135f840f47603c2b31.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:37:13',
          updated_at: '2025-07-09 14:14:52',
          deleted_at: null,
          file_name: '1bc77485e78794135f840f47603c2b31.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 21,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/1bc77485e78794135f840f47603c2b31.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 727,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '农帮主线上超市',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/eb0867cdcd215637d8770edafce07ce8.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/e3a775773c2631d7914e32490329d431.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:36:41',
          updated_at: '2025-07-14 14:12:21',
          deleted_at: null,
          file_name: 'e3a775773c2631d7914e32490329d431.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 23,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/e3a775773c2631d7914e32490329d431.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 726,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '博悦轻颜说',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/1503674b9d0651fe230327ecb56ee54d.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/d1d0a1c98b77afd18e7f215833540cca.mp4',
          share_num: 1,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:35:46',
          updated_at: '2025-07-09 14:14:59',
          deleted_at: null,
          file_name: 'd1d0a1c98b77afd18e7f215833540cca.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 22,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/d1d0a1c98b77afd18e7f215833540cca.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 725,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '禾牧联合农业科技',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/2533f11b747de3f6d3895e82263af587.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/b9820c2e5c59f27613bc346c076c729f.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:35:07',
          updated_at: '2025-04-26 01:06:29',
          deleted_at: null,
          file_name: 'b9820c2e5c59f27613bc346c076c729f.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 20,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/b9820c2e5c59f27613bc346c076c729f.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 724,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '和愿心商城',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/df28f3f17f585ce5a06db56884028cbb.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/8f54e4c2932534935f82308a3435e73b.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2025-01-02 11:34:31',
          updated_at: '2025-06-18 22:22:19',
          deleted_at: null,
          file_name: '8f54e4c2932534935f82308a3435e73b.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 21,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/8f54e4c2932534935f82308a3435e73b.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 722,
          uniacid: 10,
          uid: 111528,
          goods_id: 10409,
          title: '亿蜂云商城',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/e559671785a6cccf048a14e3d029555b.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/428a43576ff7e2bf8c1d9fba1e73c09c.mp4',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2024-12-17 16:13:07',
          updated_at: '2025-06-26 08:35:21',
          deleted_at: null,
          file_name: '428a43576ff7e2bf8c1d9fba1e73c09c.mp4',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 49,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/428a43576ff7e2bf8c1d9fba1e73c09c.mp4',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10409,
            title: '电商旗舰版 线上线下多渠道开店',
            price: '168000.00',
            market_price: '168000.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/6b27a87bd14de85cbd8ce64810a6c67d.jpg',
            has_option: 0,
            status_name: null,
            min_price: '168000.00'
          }
        },
        {
          id: 721,
          uniacid: 10,
          uid: 111528,
          goods_id: 10410,
          title: '东方灵花',
          cover: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2025/01/5d1cbd807ca7539341c84a4292eb7a0b.png',
          video: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/3bddfbdcf103f4d7c1e285e658a3035a.mov',
          share_num: 0,
          like_num: 0,
          status: 1,
          order_price: '0.00',
          amount_total: '0.00',
          created_at: '2024-12-16 17:51:34',
          updated_at: '2025-07-14 14:11:56',
          deleted_at: null,
          file_name: '3bddfbdcf103f4d7c1e285e658a3035a.mov',
          category_id: 5,
          is_recommend: null,
          store_id: 0,
          is_crm: 0,
          mid_ground_video_id: 0,
          mid_ground_config_id: 0,
          virtual_like_num: 0,
          virtual_visit_num: 0,
          visit_num: 34,
          virtual_share_num: 0,
          member_like: 1,
          room_id: null,
          is_follow: 0,
          comment_num: 0,
          is_live: 0,
          ad_serving_button_status: [],
          member_video_num: 140,
          video_src: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/newimage/3bddfbdcf103f4d7c1e285e658a3035a.mov',
          comment_sum: 0,
          member: {
            avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            uid: 111528,
            nickname: '哆禧樂',
            business_card: 2659,
            avatar_image: 'https://thirdwx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEIVPJ8UenMCF8wsuicJ8RIKDs88QTUbsicOWaPs8KnKXLic0ukx3MNzHnxHrz34FWBVta9O41ch2nic0o4uEmpiaKPiaEvqic1J2GecGWmibLqMxKjiboA/132',
            username: '哆禧樂'
          },
          goods: {
            id: 10410,
            title: '数智店铺版 打通线上商城及线下店铺',
            price: '12800.00',
            market_price: '12800.00',
            thumb: 'https://yunzmall.obs.cn-south-1.myhuaweicloud.com/images/10/2023/05/7a701317a9a999791de8c46e4c0dc6c0.jpg',
            has_option: 0,
            status_name: null,
            min_price: '12800.00'
          }
        }]

    },
    changIndex(index) {
      this.activeIndex = index
      this.activeItem = this.dataList[this.activeIndex]
    },
    openDialog() {
      window.open('https://www.yunzmall.com/addons/yun_shop/?menu#/case_library_home?i=10')
      // this.$emit('openDialog')
    },
    swiper_init() {
      this.mySwiper= new Swiper("#swiperIndex3", {
        slidesPerView: 5,
        spaceBetween: 15,
        centeredSlides: true,
        allowClick: false,
        centeredSlidesBounds:true,
        autoplay: {
          delay: 800,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
        }
      });
    
    const swiperContainer = this.$refs.swiperContainer;
    
    if(swiperContainer){
      swiperContainer.addEventListener('mouseover', () => {
        this.mySwiper.autoplay.stop();
      });
      swiperContainer.addEventListener('mouseleave', () => {
        this.mySwiper.autoplay.start();
      });
      this.$nextTick(()=>{
        this.move_handle()
      })
    }


    },

    move_handle(){
      this.mySwiper.autoplay.start();
    }

  },

  components: {},
  created() { 
    this.getData();
  
  },
  mounted() {    
    this.activeItem = this.dataList[this.activeIndex];
    this.swiper_init();

  }
};

</script>
<style scoped lang="scss">
::v-deep .swiper-slide-active {
  // height: 666px;
  transform: scale(1) !important;
}
::v-deep .swiper-slide {
  width: 289px;
  transform: scale(0.9);
}
::v-deep .swiper-slide img {
    width: 100%;
    border-radius: 16px;
  }
.swipercom-left {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  width: 406px;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.81) 40%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0px 0px 0px 0px;
}

.swipercom-right {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20;
  width: 406px;
  background: linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0.81) 40%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0px 0px 0px 0px;
  transform: scaleX(-1);
}

.play {
  position: absolute;
  top: 286px;
  left: 50%;
  transform: translateX(-50%);
  width: 94px;
  height: 94px;
  background: rgba(19, 20, 21, 0.73);
  border-radius: 50%;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;

  .iconfont {
    font-size: 45px;
    font-weight: bold;
  }
}

.part-eight ::v-deep .swiper-pagination-bullet-active {
  width: 69px !important;
  height: 9px !important;
  background: linear-gradient(90deg, #091221 0%, #404040 100%);
  border-radius: 30px 30px 30px 30px !important;
  border: none !important;
  opacity: 1 !important;
}

::v-deep .swiper-pagination {
  display: flex;
  align-items: center;
}

.part-eight ::v-deep .swiper-pagination-bullet {
  width: 69px !important;
  height: 0px;
  border: 1px solid #404040;
  opacity: 0.5;
}

#swipercom {
  width: calc(100% - 160px);
  position: relative;
  margin: 0 auto;
}

#swiperIndex3 {
  width: 100%;
  position: relative;
}


.swiper-button-prev:after,
.swiper-button-next:after {
  display: none;
}

.part-eight {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 112px;
}

.title {
  margin-top: 56px;
}

.taps {
  margin-top: 50px;
  display: flex;
  color: #000000;
  font-size: 20px;
}

.taps-item {
  width: 240px;
  text-align: center;
  cursor: pointer;
  position: relative;
}

.taps-line {
  margin-top: 14px;
  width: 1200px;
  height: 2px;
  background: #203DF5;
  opacity: 0.2;
}

.blod-line {
  width: 100%;
  height: 2px;
  position: absolute;
  background-color: #203DF5;
  bottom: -16px;
}

.img-show {
  display: flex;
  margin-top: 60px;
  width: 100%;
}

.img-show-left {
  /* width: 418px; */
  flex: 4;
  background: linear-gradient(44deg, #203DF5 0%, #3E85FF 100%);
  padding: 87px 112px 79px 17%;
  display: flex;
}

.img-show-right {
  flex: 7;
}
</style>